import React from 'react';
import styled from 'styled-components/macro';
import Tippy, { TippyProps } from '@tippyjs/react';

const Tooltip = ({ content, children, ...rest }: TippyProps): JSX.Element => {
  return (
    <StyledTippy content={content} animation={false} touch={['hold', 1000]} delay={[300, 0]} {...rest}>
      {children}
    </StyledTippy>
  );
};

const DARK_BLUE = 'var(--chakra-colors-background-contrast)';

const StyledTippy = styled(Tippy)`
  background: ${DARK_BLUE};

  &.tippy-box[data-placement^='top'] > .tippy-arrow::before {
    border-top-color: ${DARK_BLUE};
  }
  &.tippy-box[data-placement^='bottom'] > .tippy-arrow::before {
    border-bottom-color: ${DARK_BLUE};
  }
  &.tippy-box[data-placement^='left'] > .tippy-arrow::before {
    border-left-color: ${DARK_BLUE};
  }
  &.tippy-box[data-placement^='right'] > .tippy-arrow::before {
    border-right-color: ${DARK_BLUE};
  }

  & a,
  & a:visited {
    color: #fff;
    font-weight: 600;
    transition: color 0.1s ease-in-out;

    &:hover {
      color: var(--chakra-colors-text-brand);
    }
  }
`;

export default Tooltip;
